// extracted by mini-css-extract-plugin
export default {"footerContainer":"ModalFooter__footerContainer___twkkS","rightContainer":"ModalFooter__rightContainer___ujCn0","skeleton-loading":"ModalFooter__skeleton-loading___vfnbD"};